module.exports = __webpack_public_path__ + "static/media/dinnerMenu.101367d9.jpg";